import React, {FC} from 'react';
import ReactSelect, {ActionMeta, Props, PropsValue} from 'react-select';

export type TOption = {
    value: number | string | number[] | null;
    label: string;
}

export interface ISelect extends Props<PropsValue<any>> {
  defaultValue?: any,
  onChange?: (newValue: TOption, actionMeta: ActionMeta<any>) => void
  options?: TOption[],
  name?: string,
  minHeight?: number,
  isSearchable?: boolean,
  getOptionLabel?: any,
  props?: any,
  className?: any,
  isDisabled?: boolean,
  value?: any,
  isClearable?: boolean,
  isMulti?: boolean,
}

const Select: FC<ISelect> = (
  {
    name,
    options,
    defaultValue,
    onChange,
    minHeight = 48,
    isSearchable = false,
    className,
    value,
    isClearable,
    ...props
  }) => {

  const selectCustomStyles = {
    control: (styles: any) => ({
      ...styles,
      minHeight,
    })
  }

  return (
    <ReactSelect
      className={className}
      placeholder='Выберите'
      isClearable={isClearable}
      name={name}
      defaultValue={defaultValue}
      options={options}
      isSearchable={isSearchable}
      styles={selectCustomStyles}
      onChange={onChange}
      value={value}
      components={{
        IndicatorSeparator: () => null,
      }}
      {...props}
    />
  )
}

export default Select
